import React, { useEffect, useMemo, useRef, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector, useDispatch } from "react-redux";
import { tokens } from "../../../theme";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import {
  addVariation,
  modifyVariation,
  deleteVariation,
  getVariations,
  getVariationError,
  getVariationStatus,
  selectAllVariations,
  updateStatus,
  getVariationSuccess,
} from "../../../features/variationSlice";
import Loading from "../../../components/loading";
import Error from "../../../components/Error";
import AlertDialog from "../../../components/alertDialog";
import { toast } from "react-toastify";
import AppBarSearch from "../../../global/appBarSearch";
import NoDataTable from "../../../components/noDataTable";
import { Formik } from "formik";
import * as yup from "yup";
import TextFieldCompnent from "../../../components/textFieldComponent";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import ParagraphHighliter from "../../../components/paragraphHighliter";
import { ResponsiveProvider } from "../../../hooks/uiHook";
import { useTranslation } from "react-i18next";
import TableActions from "../../../components/tableActions";
const Variantion = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { restaurantId } = useRestaurant();
  const [localVariations, setLocalVariations] = useState([]);
  const [open, setOpen] = useState(false);
  const [addOrModify, setAddOrModify] = useState("");
  const [addModifyOpen, setAddModifyOpen] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [search, setSearch] = useState("");
  const status = useSelector(getVariationStatus);
  const error = useSelector(getVariationError);
  const variations = useSelector(selectAllVariations);
  const success = useSelector(getVariationSuccess);

  const schema = yup.object().shape({
    name: yup.string().required("Nom est requis"),
  });

  const handleClickOpen = (cardId) => {
    setOpen(true);
    setCardId(cardId);
  };

  const handleAddOpen = (cardId, type) => {
    if (type === "add") {
      setCardId("");
      setAddOrModify("add");
    } else {
      setCardId(cardId);
      setAddOrModify("edit");
    }
    setAddModifyOpen(true);
  };

  const handleClose = () => {
    setAddModifyOpen(false);
  };

  const hasFetchedInMountRef = useRef(false);
  const lastFetchedRestaurantRef = useRef(restaurantId);
  useEffect(() => {
    const restaurantChanged =
      hasFetchedInMountRef.current &&
      lastFetchedRestaurantRef.current !== restaurantId;
    const alreadyLoaded = variations.length > 0 && status === "fetchVariation";
    if (restaurantChanged || !alreadyLoaded) {
      dispatch(getVariations(restaurantId));
    }
    hasFetchedInMountRef.current = true;
    lastFetchedRestaurantRef.current = restaurantId;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, restaurantId]);

  useEffect(() => {
    if (status === "fetchVariation") setLocalVariations(variations);
  }, [variations, status]);

  const filteredVariationsMemo = useMemo(() => {
    return (localVariations || []).filter((dish) =>
      (dish.name || "").toLowerCase().includes(search.toLowerCase())
    );
  }, [localVariations, search]);

  useEffect(() => {
    if (status === "deleteSuccess") {
      toast.success(success);
      setLocalVariations((prev) =>
        prev.filter((item) => item._id !== cardId)
      );
      dispatch(updateStatus());
    } else if (status === "deleteError") {
      toast.error(error);
    }
  }, [cardId, dispatch, error, status, success]);

  const handleFormSubmit = (values) => {
    if (addOrModify === "add") {
      dispatch(addVariation({ body: { name: values.name }, restaurantId }));
    } else {
      dispatch(
        modifyVariation({
          body: { name: values.name },
          variationId: cardId,
          restaurantId,
        })
      );
    }
    setAddModifyOpen(false);
  };

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      dispatch(getVariations(restaurantId));
      dispatch(updateStatus());
    } else if (status === "addError") {
      toast.error(error);
      dispatch(updateStatus());
    } else if (status === "modifySuccess") {
      setCardId("");
      toast.success(success);
      dispatch(getVariations(restaurantId));
      dispatch(updateStatus());
    } else if (status === "modifyError") {
      toast.error(error);
      dispatch(updateStatus());
    }
  }, [status, error, dispatch, success, restaurantId]);
  return (
    <div className="main-application">
      <CssBaseline />
      <ResponsiveProvider maxWidth={900}>
      <AppBarSearch
        handleSubmit={() => handleAddOpen("", "add", "")}
        handleSearch={(e) => setSearch(e.target.value)}
        title={t("pages.myVariations")}
        buttonTitle={t("actions.addVariation")}
      />
      </ResponsiveProvider>
      <main>
        <Box sx={{ my: 2 }}>
          <TableContainer>
            <Table
              sx={{
                backgroundColor: colors.primary[400],
              }}
            >
              <TableHead
                sx={{
                  backgroundColor: colors.primary[700],
                }}
              >
                <TableRow>
                  <TableCell>{t("table.name")}</TableCell>
                  <TableCell align="right">{t("table.actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {status === "loadingFetchVariation" ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <Loading size={8} />
                    </TableCell>
                  </TableRow>
                ) : status === "fetchError" ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <Error>{error}</Error>
                    </TableCell>
                  </TableRow>
                ) : filteredVariationsMemo && filteredVariationsMemo.length > 0 ? (
                  filteredVariationsMemo.map((card) => (
                    <TableRow key={card._id}>
                      <TableCell>
                        <ParagraphHighliter
                          title={card.name}
                          search={search}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <TableActions
                          actions={[
                            {
                              type: "delete",
                              color: "error",
                              label: t("common.delete"),
                              onClick: () => handleClickOpen(card._id),
                            },
                            {
                              type: "edit",
                              color: "warning",
                              label: t("common.edit"),
                              onClick: () => handleAddOpen(card._id, "edit"),
                            },
                          ]}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <NoDataTable cols={2} />
                )}
                <Dialog open={addModifyOpen} onClose={handleClose}>
                  <Formik
                    onSubmit={handleFormSubmit}
                    initialValues={{
                      name:
                        addOrModify === "edit"
                          ? filteredVariationsMemo.find(
                            (item) => item._id === cardId
                          )?.name
                          : "",
                    }}
                    validationSchema={schema}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <DialogTitle>
                          {addOrModify === "edit"
                            ? t("actions.editVariationTitle")
                            : t("actions.addVariationTitle")}
                        </DialogTitle>
                        <DialogContent>
                          <TextFieldCompnent
                            type="text"
                            label={t("fields.name")}
                            change={handleChange}
                            value={values.name}
                            name="name"
                            blur={handleBlur}
                            touched={touched.name}
                            error={errors.name}
                            required
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose} color="error">
                            {t("common.cancel")}
                          </Button>
                          <Button type="submit" color="secondary">
                            {t("common.confirm")}
                          </Button>
                        </DialogActions>
                      </form>
                    )}
                  </Formik>
                </Dialog>
                <AlertDialog
                  handleClose={() => setOpen(false)}
                  open={open}
                  message={"Voulez-vous supprimer cette variation ?"}
                  cardId={cardId}
                  deleteData={() =>
                    dispatch(
                      deleteVariation({
                        variationId: cardId,
                        restaurantId,
                      })
                    )
                  }
                />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </main>
    </div>
  );
};

export default Variantion;
